import { render, staticRenderFns } from "./PreviousUsers.vue?vue&type=template&id=1f3caa62&"
import script from "./PreviousUsers.vue?vue&type=script&lang=js&"
export * from "./PreviousUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports